import request from '../utils/request';
import { APIHOST } from '../config';

export async function updateLoginShortMessage(payload) {
  const { token } = payload;
  const path = '/v1/login_short_messages/:token'.replace(':token', token);
  return request('PUT', APIHOST + path);
}
